import { createAsyncThunk } from '@reduxjs/toolkit'
import ProfileComment from './profile-comment-model'
import {
  delete_profileComment,
  load_profileComments,
  store_profileComment,
} from './profileComment-service'

export const LoadProfileCommentsAsync = createAsyncThunk<any, any>(
  'composer/load/profileComment',
  async (params: { uid: string }) => {
    return await load_profileComments(params)
  },
)

export const CreateProfileCommentAsync = createAsyncThunk<any, any>(
  'composer/create/profileComment',
  async (params: ProfileComment) => {
    return await store_profileComment(params)
  },
)

export const DeleteProfileCommentAsync = createAsyncThunk<any, any>(
  'composer/delete/profileComment',
  async (params) => {
    return await delete_profileComment(params)
  },
)
